import useSubscriber from '@hooks/useSubscriber';
import { useIsNewIngest } from '@hooks/useTitlesDataSource';
import useSearchAndFilter from '@modules/layouts/hooks/useSearchAndFilter';

import { fetchPlaybackOption, fetchSuggestedValues, fetchTitle, searchTitles } from '../services/titles';
import { ApiContext } from '../shared/types';

export const useTitlesApi = () => {
  const {
    searchQuery: { indexName },
  } = useSearchAndFilter();

  const { subscriber: { atsToken } = {} } = useSubscriber();
  const isNewIngest = useIsNewIngest();

  const apiContext: ApiContext = { atsToken, indexName, isNewIngest };

  return {
    getTitle: fetchTitle(apiContext),
    getPlaybackOption: fetchPlaybackOption(apiContext),
    searchTitles: searchTitles(apiContext),
    suggestValues: fetchSuggestedValues(apiContext),
  };
};
